import whenDomReady from 'when-dom-ready';
function initialise() {
    const warningBanners = document.querySelectorAll('.homepage-top-banner');
    warningBanners.forEach(warningBanner => {
        const closeButton = warningBanner.querySelector('.homepage-top-banner-close');
        if (!closeButton) {
            return;
        }
        closeButton.addEventListener('click', () => {
            warningBanner.classList.add('hidden');
        });
    });
}
whenDomReady().then(initialise);
